import { render, staticRenderFns } from "./CarPainting.vue?vue&type=template&id=6386dfe2"
import script from "./CarPainting.vue?vue&type=script&lang=js"
export * from "./CarPainting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports